<template>
  <div id="app">
    <el-header>
      <el-row>
        <el-col :span="5" :offset="19">
          <el-button v-show="!user" round type="warning" @click="connect">Connect Wallet</el-button>
          <el-button round v-show="user" type="success">{{ shortUser }}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="14" :offset="5">
          <babylon
            model="https://bafybeidxcaob6op7bq5djmln36behml5524k5rupejnwinjfmkvkqbqkja.ipfs.infura-ipfs.io/eWatch.glb"
          ></babylon>
          <!-- <babylon extends="minimal">
            <model
              url="https://cloudflare-ipfs.com/ipfs/QmQCBsB9QHMU4hGsgwpaFL32EbSxWCqcE9j3chAyE4Z5px"
            ></model>
            <camera behaviors.auto-rotate.type="0"></camera>
            <lights>
              <light1 type="1" shadow-enabled="true"></light1>
            </lights>
          </babylon>-->
        </el-col>
      </el-row>
      <!-- <div style="text-align: center;">
        <babylon
          model="https://cloudflare-ipfs.com/ipfs/bafybeif2wobpdjlkv7k33k2at4agirvmrs5zqa7hm4wvz72teui6bttg7y/rss3-whitepaper-no-1.glb"
        ></babylon>
        <img src="./assets/logo.png" style="margin: 0 auto;" width="300" />
      </div>-->

      <h1>ENU Watch NFT Free Mint</h1>
      <div style="padding-left: 5%;padding-right: 5%;">
        <!-- <div style="margin: 15px;">
          <el-input v-model="input" placeholder="请输入内容"></el-input>
        </div>-->
        <h2>
          Step1 :
          <a href="https://enu-nft.xyz" target="_blank">How to Mint</a>
        </h2>

        <el-row>
          <el-col :span="4">
            <el-button @click="refresh()" round type="danger" icon="el-icon-refresh">Refresh</el-button>
          </el-col>
          <el-col :span="16">
            <!-- <el-input v-model="search" placeholder="Search Address"></el-input> -->
            <el-input v-model="user" placeholder="Your Address" disabled></el-input>
          </el-col>
          <!-- <el-col :span="4">
            <el-button
              v-show="user"
              @click="searchMy()"
              round
              type="success"
              icon="el-icon-search"
            >MyRecord</el-button>
          </el-col>-->
        </el-row>
        <el-table
          :data="filterData"
          v-loading="loading"
          element-loading-text="Loading"
          element-loading-spinner="el-icon-loading"
          stripe
          max-height="700px"
          style="width: 100%"
        >
          <template slot="empty">No Record</template>
          <el-table-column prop="eth_address" label="Polygon Address"></el-table-column>
          <el-table-column prop="last_claim_time" label="Burn Time"></el-table-column>
          <el-table-column prop="amount" label="Amount" width="100px"></el-table-column>
          <!-- <el-table-column prop="claimer" label="ENU Account" width="130px"></el-table-column> -->
          <el-table-column prop="is_user" label width="100px">
            <template slot-scope="scope">
              <el-button
                round
                v-show="scope.row.is_user && user && !hasMinted"
                @click="mint(scope.row)"
                type="primary"
                size="small"
              >Mint</el-button>
              <el-button
                round
                v-show="scope.row.is_user && user && hasMinted"
                type="danger"
                size="small"
              >Minted</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-main>
    <div style="padding-top: 30px;">
      <a href="mailto:help@enu-nft.xyz">
        <img src="./assets/icons8-email-64.png" width="30" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      user: null,
      tableData: [],
      search: "",
      loading: true,
      hasMinted: false
    }
  },
  computed: {
    filterData() {
      const search = this.search
      if (search.length > 0) {
        return this.tableData.filter(row => {
          return Object.keys(row).some(key => {
            return String(row[key]).toLowerCase().indexOf(search) > -1
          })
        })
      } else {
        return this.tableData
      }
    },
    shortUser() {
      if (this.user) {
        const user = this.user
        console.log({ user })
        return user.substr(0, 6) + "...." + user.substr(user.length - 5, 5)
      }
    }
  },
  created() {
    // this.api.getRecords().then(res => {
    //   const records = []
    //   for (const record of res.data) {
    //     records.push({
    //       last_claim_time: new Date(record.last_claim_time * 1000).toUTCString(),
    //       amount: record.amount,
    //       claimer: record.claimer,
    //       eth_address: record.eth_address,
    //       // is_user: this.user == record.eth_address
    //       is_user: true
    //     })
    //   }
    //   console.log(records)
    //   this.tableData = records
    //   this.loading = false
    // })
    this.connect().then(() => {
      this.refresh()
    })
    setInterval(() => {
      if (!this.user) {
        this.refresh()
      }
    }, 5000)
  },
  methods: {
    connect() {
      // console.log("alet")
      // alert("connect")
      if (typeof ethereum == 'undefined') {
        alert('MetaMask is installed!');
        return
      }
      return ethereum.request({ method: 'eth_requestAccounts' }).then(accounts => {
        this.user = accounts[0];
        return ethereum.request({ method: 'eth_chainId' })
      }).then(chainId => {
        console.log({ chainId })
        if (chainId != this.globalVars.chainId) {
          // alert("please switch to " + this.globalVars.chainName)
          return window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: this.globalVars.chainId }], // chainId must be in hexadecimal numbers
          });
        }
      }).then(res => {
        window.web3 = new window.Web3(window.web3.currentProvider)
        const abi = [
          {
            "inputs": [
              {
                "internalType": "address",
                "name": "",
                "type": "address"
              }
            ],
            "name": "hasMinted",
            "outputs": [
              {
                "internalType": "bool",
                "name": "",
                "type": "bool"
              }
            ],
            "stateMutability": "view",
            "type": "function",
            "constant": true
          }
        ]
        const nft_contract = new window.web3.eth.Contract(abi, this.globalVars.contract);
        nft_contract.methods.hasMinted(this.user).call().then(res => {
          // console.log("hasMinted", res)
          this.hasMinted = res
        })
      })
    },
    mint(row) {
      console.log(row)
      const { amount, eth_address } = row
      this.api.getSig(eth_address).then(_result => {
        console.log(_result)
        const { signature, salt } = _result
        console.log({ amount })
        console.log(window.web3)
        // alert(row.eth_address)
        window.web3 = new window.Web3(window.web3.currentProvider)
        // const sig = window.web3.utils.asciiToHex("123sdfefasgs")
        // console.log({ sig })
        const data = window.web3.eth.abi.encodeFunctionCall({
          name: 'mint',
          type: 'function',
          inputs: [{
            type: 'uint8',          // name: 'amount'
          }, {
            type: 'string',          // name: 'salt'
          }, {
            type: 'bytes'         //sig
          }]
        }, [amount, salt, signature]);

        const transactionParameters = {
          // nonce: '0x00', // ignored by MetaMask
          // gasPrice: '0x09184e72a000', // customizable by user during MetaMask confirmation.
          gas: (200000 * amount).toString(16), //500000 // customizable by user during MetaMask confirmation.
          to: this.globalVars.contract, // Required except during contract publications.
          from: this.user, // must match user's active address.
          value: '0x00', // Only required to send ether to the recipient from the initiating external account.
          data, // Optional, but used for defining smart contract creation and interaction.
          // chainId: '0x3', // Used to prevent transaction reuse across blockchains. Auto-filled by MetaMask.
        };
        // estimate
        // window.web3.eth.estimateGas({
        //   to: this.globalVars.contract, value: '0x00', data,
        // }).catch(err => {
        //   console.error(err)
        // }).then(estimate_result => {
        //   console.log(estimate_result); 
        ethereum.request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(txHash => {
          // alert(txHash)
          this.txSent(txHash)
          this.hasMinted = true
        })
        // })
      })

    },
    searchMy() {
      this.search = this.user
    },
    refresh() {
      this.loading = true
      this.api.getRecord(this.user).then(res => {
        const records = []
        if (res) {
          const record = res
          records.push({
            last_claim_time: new Date(record.last_claim_time * 1000).toUTCString(),
            amount: record.amount,
            claimer: record.claimer,
            eth_address: record.eth_address,
            // is_user: this.user == record.eth_address
            is_user: true
          })
        }
        // for (const record of res.data) {
        //   records.push({
        //     last_claim_time: new Date(record.last_claim_time * 1000).toUTCString(),
        //     amount: record.amount,
        //     claimer: record.claimer,
        //     eth_address: record.eth_address,
        //     // is_user: this.user == record.eth_address
        //     is_user: true
        //   })
        // }
        console.log(records)
        this.tableData = records
        setTimeout(() => {
          this.loading = false
        }, 200)
      })
    },
    txSent(txid) {
      this.$confirm(txid, 'Tx Sent', {
        confirmButtonText: 'Open in explorer',
        cancelButtonText: 'Close',
        type: 'success',
        center: true,
        roundButton: true
      }).then(() => {
        window.open('https://polygonscan.com/tx/' + txid, '_blank')
      })
    }
  }
}

ethereum.on('chainChanged', handleMetamaskChanged);
ethereum.on('accountsChanged', handleMetamaskChanged);

function handleMetamaskChanged() {
  // We recommend reloading the page, unless you must do otherwise
  window.location.reload();
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.el-message-box {
  width: 600px;
}
body {
  height: 100%;
}
.el-main {
  position: relative;
  min-height: 100%;
  padding-bottom: 50px;
  box-sizing: border-box;
}
.footer {
  position: absolute;
  bottom: 0;
  height: 50px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue